import { Color } from "../../shared/Expr"
import { Parameter } from "../../shared/Parameter"
import { CheckboxChip } from "./CheckboxChip"

type ParameterChipPropsT<T extends Parameter["type"], V> = {
  type: T
  id: string
  name: string
  checked: boolean
  value: V
  onClick: (id: string) => void
}

type ParameterChipProps =
  | ParameterChipPropsT<"boolean", boolean>
  | ParameterChipPropsT<"number", number>
  | ParameterChipPropsT<"color", Color>
  | ParameterChipPropsT<"string", string>

export function ParameterChip({
  id,
  type,
  name,
  checked,
  value,
  onClick,
}: ParameterChipProps) {
  return (
    <CheckboxChip onClick={() => onClick(id)} checked={checked}>
      <div
        style={{
          borderRadius: 2,
          width: 30,
          height: 18,
          background: type === "color" ? (value as string) : undefined,
        }}
      >
        {type !== "color" ? value : undefined}
      </div>
      {name}
    </CheckboxChip>
  )
}
